import '../../../src/components/VGrid/_grid.sass';
import Grid from './grid';
export default Grid('flex');
//# sourceMappingURL=VFlex.js.map